module.exports = __webpack_public_path__ + "static/aboleth-6562969d1d34e28a80b24b7748ee36a6.jpg";